import React, { useEffect, useMemo, useRef, useState } from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useDispatch, useSelector } from 'react-redux';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import Addbatch from './AddBatch';
import { Autocomplete, Box, Button, Chip, Grid, Stack, TextField, Typography, Switch } from '@mui/material';
import { Batch_View_Table_Head } from '../../components/datagrid/myworkspace/cro/BatchViewTableHead';
import GlobalDatagrid from '../../components/mui/DataGrid/GlobalDatagrid';
import { getBatchesList, getCardsData, getCourseAvailable, changeEnableStatus } from '../../redux/features/batchSlice';
import { savePaginationData } from '../../redux/features/globalDatagridSlice';
import { Icon } from '@iconify/react/dist/iconify.js';
import BatchStatus from './BatchStatus';
import DeleteBatch from './DeleteBatch';
import { useNavigate } from 'react-router-dom';
import Searchbar from '../../components/Search/Searchbar';
import GlobalSelectField from '../../components/mui/GlobalSelectField';
import AssignCro from './AssignCro';
import StartBatchButton from './StartBatch';
import AssignBatch from './Assignbatch';
import ChangeBatch from './ChangeBatch';
import Subjects from './Subjects';
import CardsData from './CardsData';
import StartConfirmation from './StartStopConfirmation';
import { set } from 'lodash';
import dayjs from 'dayjs';
import SessionPreference from './SessionPreference';
import BatchSyncStatus from './BatchSyncStatus';

const Batchlanding = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { loading, batches, allcourses, cardData } = useSelector((state) => state.batch);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const [statusOpen, setStatusOpen] = useState(false);
  const [assignopen, setAssignOpen] = useState(false);
  const [changeOpen, setChangeopen] = useState(false);
  const [startOpen, setStartOpen] = useState(false);
  const [type, setType] = useState('');
  const [addOpen, setAddOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [subjectsOpen, setSubjectsOpen] = useState(false);
  const [editresOpen, setEditresOpen] = useState(false);
  const [sessionPreferenceOpen, setSessionPreferenceOpen] = useState(false);
  const [syncStatusOpen, setSyncStatusOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [course, setSelectedCourse] = useState('');
  const [status, setSelectedStatus] = useState('');
  const navigate = useNavigate();
  const [value, setValue] = useState('');
  const [currentRowDetails, setCurrentRowDetails] = useState(null);
  const [toggleStates, setToggleStates] = useState({});
  const profile = JSON.parse(localStorage.getItem('cred')).profile;
  const isCRM = profile?.isReportingHead === true;

  const skillx = profile?.departmentId === 35;

  // Grid toolbar search (paginationData.search) takes priority; falls back to the Search Batch box.
  const searchText = (search || '').trim() || value;

  const data = {
    page: pageNum,
    limit: gridSize,
    search: searchText,
    course_available_id: course || '',
    course_batch_status: status || '',
  };

  // A new search/filter should start from page 1; the pageNum change then triggers the fetch.
  const prevFilters = useRef(null);
  useEffect(() => {
    const filters = JSON.stringify([searchText, course, status]);
    const filtersChanged = prevFilters.current !== null && prevFilters.current !== filters;
    prevFilters.current = filters;
    if (filtersChanged && pageNum !== 1) {
      dispatch(savePaginationData({ ...paginationData, pageNum: 1 }));
      return;
    }
    if (pageNum && gridSize) {
      dispatch(getBatchesList(data));
    }
  }, [pageNum, gridSize, searchText, course, status]);

  useEffect(() => {
    dispatch(getCourseAvailable());
  }, []);

  useEffect(() => {
    if (batches?.data?.length) {
      const initialToggleState = {};

      batches.data.forEach((item) => {
        initialToggleState[item.course_batch_id] = Number(item.is_student_enrollment_enabled) === 1;
      });

      setToggleStates(initialToggleState);
    }
  }, [batches?.data]);

  // ✅ FIX: Sync selectedRow with the latest batches data after any list refresh.
  // This ensures enableReinitialize in Formik picks up the updated values
  // (e.g. allow_all_cro_student_access) instead of the stale click-time snapshot.
  useEffect(() => {
    if (selectedRow && batches?.data?.length) {
      const updatedRow = batches.data.find((b) => b.course_batch_id === selectedRow.course_batch_id);
      if (updatedRow) {
        setSelectedRow(updatedRow);
      }
    }
  }, [batches?.data]);

  const columns = useMemo(
    () => [
      ...Batch_View_Table_Head,
      ...(skillx
        ? [
            {
              field: 'class_mode',
              headerName: 'Class Mode',
              width: 150,
            },
          ]
        : []),
      ...(skillx
        ? [
            {
              field: 'offlineCenter',
              headerName: 'Center',
              width: 150,
            },
          ]
        : []),
      {
        field: 'subjectslist',
        minWidth: 200,
        headerName: 'Subjects',
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="outlined"
              color="primary"
              startIcon={<Icon icon={'lsicon:view-filled'} width={18} height={18} />}
              onClick={() => {
                setSelectedRow(params.row);
                setSubjectsOpen(true);
              }}
            >
              Subjects
            </Button>
          );
        },
      },
      {
        field: 'sessionpreference',
        minWidth: 200,
        headerName: 'Session Preference',
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="outlined"
              color="primary"
              endIcon={<Icon icon={'mdi:calendar-time'} width={18} height={18} />}
              onClick={() => {
                setSelectedRow(params.row);
                setSessionPreferenceOpen(true);
              }}
            >
              Session Preference
            </Button>
          );
        },
      },
      {
        field: 'syncStatus',
        minWidth: 200,
        headerName: 'Lens Sync Status',
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="outlined"
              color="primary"
              startIcon={<Icon icon={'mdi:sync'} width={18} height={18} />}
              onClick={() => {
                setSelectedRow(params.row);
                setSyncStatusOpen(true);
              }}
            >
              Sync Status
            </Button>
          );
        },
      },
      {
        field: 'status',
        minWidth: 200,
        headerName: 'Temporary Inactive',
        renderCell: (params) => {
          if (params.row.courseBatchStatus === 'Temporary Inactive') {
            return (
              <Button
                size="small"
                variant="outlined"
                color="primary"
                startIcon={<Icon icon={'lets-icons:date-range'} width={18} height={18} />}
                onClick={() => {
                  setSelectedRow(params.row);
                  setEditresOpen(true);
                }}
              >
                Update Restart Date
              </Button>
            );
          } else {
            return (
              <Button
                size="small"
                variant="outlined"
                color="error"
                disabled={params.row.courseBatchStatus !== 'Active'}
                startIcon={<Icon icon={'icomoon-free:pause'} width={18} height={18} />}
                onClick={() => {
                  setSelectedRow(params.row);
                  setStatusOpen(true);
                }}
              >
                Temporary Inactive
              </Button>
            );
          }
        },
      },
      {
        field: 'batchchange',
        minWidth: 200,
        headerName: 'Change Batch',
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="contained"
              color="primary"
              startIcon={<Icon icon={'la:exchange-alt'} width={18} height={18} />}
              onClick={() => {
                setSelectedRow(params.row);
                setChangeopen(true);
              }}
            >
              Change Batch
            </Button>
          );
        },
      },
      {
        field: 'assign',
        minWidth: 200,
        headerName: 'Assign Tutor',
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              startIcon={<Icon icon={'clarity:assign-user-solid'} width={18} height={18} />}
              onClick={() => {
                navigate(`/my-workspace/batch-assigned-tutor?BatchID=${params.row.course_batch_id}`);
              }}
            >
              Tutors
            </Button>
          );
        },
      },
      {
        field: 'start',
        minWidth: 180,
        headerName: 'Start Batch',
        renderCell: (params) => {
          if (params.row.courseBatchStatus === 'Upcoming' || params.row.courseBatchStatus === 'Temporary Inactive') {
            return (
              <Button
                size="small"
                variant="contained"
                color="primary"
                disabled={params.row.cro_assigned === null}
                startIcon={<Icon icon={'ic:outline-not-started'} width={18} height={18} />}
                onClick={() => {
                  setSelectedRow(params.row);
                  setStartOpen(true);
                  setType('Start');
                }}
              >
                {params.row.courseBatchStatus === 'Temporary Inactive' && params.row.cro_assigned !== null
                  ? 'Restart Batch'
                  : 'Start Batch'}
              </Button>
            );
          } else if (params.row.courseBatchStatus === 'Active') {
            return (
              <Button
                size="small"
                variant="contained"
                color="error"
                startIcon={<Icon icon={'icomoon-free:stop'} width={18} height={18} />}
                onClick={() => {
                  setSelectedRow(params.row);
                  setStartOpen(true);
                  setType('Stop');
                }}
              >
                Stop Batch
              </Button>
            );
          } else {
            return <Chip label="Batch Completed" variant="outlined" color="success" />;
          }
        },
      },
      {
        field: 'studentadmission',
        minWidth: 150,
        headerName: 'Student Details',
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="contained"
              color="secondary"
              startIcon={<Icon icon={'ep:list'} width={18} height={18} />}
              onClick={() => {
                navigate(`/my-workspace/admission-batch-register?BatchID=${params.row.course_batch_id}`);
              }}
            >
              Student Details
            </Button>
          );
        },
      },
      {
        field: 'batchCalendar',
        headerName: 'Batch Calendar',
        width: 200,
        renderCell: (params) => (
          <Button
            startIcon={<Icon icon="mdi:eye" />}
            variant="outlined"
            size="small"
            onClick={() => {
              navigate(`/my-workspace/batch-academic-calendar?BatchID=${params.row.course_batch_id}`, {
                state: { batchDetails: params.row },
              });
            }}
          >
            View Batch Calendar
          </Button>
        ),
      },
      {
        field: 'batchCalendarEdit',
        headerName: 'Batch Calendar Edit',
        width: 200,
        renderCell: (params) => (
          <Button
            startIcon={<EditOutlinedIcon />}
            variant="outlined"
            size="small"
            onClick={() => {
              navigate(`/my-workspace/batch-calendar-edit/${params.row.course_batch_id}`, {
                state: { batchDetails: params.row },
              });
            }}
          >
            Batch Calendar Edit
          </Button>
        ),
      },
      {
        field: 'feeforecast',
        headerName: 'View Fee Forecasting',
        width: 180,
        renderCell: (params) => (
          <Button
            sx={{ px: 1 }}
            startIcon={<Icon icon="famicons:navigate" />}
            variant="outlined"
            size="small"
            onClick={() => {
              window.open(`/dashboard/fee-forecasting`, '_blank');
            }}
          >
            Fee Forecasting
          </Button>
        ),
      },

      //ogd toggle column

      ...(isCRM
        ? [
            {
              field: 'ogdsToggle',
              headerName: 'OGDS View',
              width: 180,
              renderCell: (params) => {
                const batchId = params.row.course_batch_id;

                return (
                  <Switch
                    checked={!!toggleStates[batchId]}
                    onChange={async (e) => {
                      const checked = e.target.checked;

                      setToggleStates((prev) => ({
                        ...prev,
                        [batchId]: checked,
                      }));

                      try {
                        const response = await dispatch(
                          changeEnableStatus({
                            is_student_enrollment_enabled: checked ? 1 : 0,
                            batch_id: batchId,
                          }),
                        );

                        if (response?.payload?.status !== 'success') {
                          setToggleStates((prev) => ({
                            ...prev,
                            [batchId]: !checked,
                          }));
                        }
                      } catch (error) {
                        setToggleStates((prev) => ({
                          ...prev,
                          [batchId]: !checked,
                        }));
                      }
                    }}
                    color="primary"
                  />
                );
              },
            },
          ]
        : []),
      // NEW COLUMN  FOR CRO ACCESS
      {
        field: 'croAccess',
        headerName: 'CRO Student Access',
        width: 220,

        renderCell: (params) => {
          const isEnabled = Number(params.row.allow_cro_view) === 1;

          return <Chip label={isEnabled ? 'ON' : 'OFF'} color={isEnabled ? 'success' : 'error'} variant="outlined" />;
        },
      },
      {
        field: 'actions',
        minWidth: 200,
        headerName: 'Actions',
        renderCell: (params) => {
          return (
            <Stack direction={'row'} spacing={2}>
              <Button
                size="small"
                color="primary"
                variant="outlined"
                startIcon={<Icon icon={'mdi:edit'} width={18} height={18} />}
                onClick={() => {
                  setSelectedRow(params.row);
                  setEditOpen(true);
                }}
              >
                Edit
              </Button>
              <DeleteBatch
                id={params.row.course_batch_id}
                dispatchdata={data}
                disabled={params.row.courseBatchStatus !== 'Upcoming'}
              />
            </Stack>
          );
        },
      },
    ],
    [Batch_View_Table_Head, toggleStates],
  );

  const handlecourses = (e, option) => {
    setSelectedCourse(option?.course_available_id || '');
  };
  const handlestatus = (e, option) => {
    setSelectedStatus(option?.id || '');
  };

  const BatchStatuses = [
    { id: 1, name: 'Active' },
    { id: 2, name: 'Temporary Inactive' },
    { id: 3, name: 'Upcoming' },
    { id: 4, name: 'Completed' },
  ];

  return (
    <GlobalWrapper
      title={'Batch Register'}
      // actions={<Addbatch dispatchParams={data} />}
      // actions={<AssignBatch />}
    >
      <CardsData />
      <Box
        sx={{
          width: '100%',
          padding: 0,
          mb: 2,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Searchbar value={value} setValue={setValue} label={'Search Batch'} />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Autocomplete
              name="Courses"
              fullWidth
              options={allcourses}
              getOptionLabel={(option) => option.course_name || ''}
              onChange={handlecourses}
              value={allcourses.find((courseOption) => courseOption.course_available_id === course) || ''}
              renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Courses" />}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Autocomplete
              name="Status"
              fullWidth
              options={BatchStatuses}
              getOptionLabel={(option) => option.name || ''}
              onChange={handlestatus}
              value={BatchStatuses.find((statuses) => statuses.id === status) || ''}
              renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Status" />}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button
              size="medium"
              variant="outlined"
              color="primary"
              startIcon={<Icon icon={'ri:add-line'} width={18} height={18} />}
              onClick={() => {
                setAddOpen(true);
              }}
            >
              Add Batch
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ width: '100%', padding: 0 }}>
        {currentRowDetails?.course_batch_name && (
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
            Batch Name : <strong>{currentRowDetails?.course_batch_name}</strong>
          </Typography>
        )}
        <GlobalDatagrid
          tableHead={columns}
          rows={batches?.data}
          meta={batches?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="course_batch_id"
          rowClick={false}
          setCurrentRowDetails={setCurrentRowDetails}
          // actionComponent={
          //   <>
          //     <ActionDetails val={rowData?.batchName} />
          //     <GlobalAnchorList
          //       label=""
          //       component={<AssignTutor rowData={rowData} />}
          //     />
          //   </>
          // }
        />
        {addOpen && <Addbatch open={addOpen} setOpen={setAddOpen} dispatchParams={data} />}
        {editOpen && selectedRow && (
          <Addbatch row={selectedRow} open={editOpen} setOpen={setEditOpen} dispatchParams={data} />
        )}
        {subjectsOpen && selectedRow && (
          <Subjects rowData={selectedRow} open={subjectsOpen} setOpen={setSubjectsOpen} />
        )}
        {sessionPreferenceOpen && selectedRow && (
          <SessionPreference
            rowData={selectedRow}
            open={sessionPreferenceOpen}
            setOpen={setSessionPreferenceOpen}
            dispatchData={data}
          />
        )}
        {syncStatusOpen && selectedRow && (
          <BatchSyncStatus rowData={selectedRow} open={syncStatusOpen} setOpen={setSyncStatusOpen} />
        )}
        {statusOpen && selectedRow && (
          <BatchStatus rowData={selectedRow} open={statusOpen} setOpen={setStatusOpen} dispatchData={data} />
        )}
        {editresOpen && selectedRow && <BatchStatus edit={selectedRow} open={editresOpen} setOpen={setEditresOpen} />}
        {changeOpen && selectedRow && (
          <ChangeBatch rowData={selectedRow} open={changeOpen} setOpen={setChangeopen} dispatchData={data} />
        )}
        {assignopen && selectedRow && (
          <AssignCro rowData={selectedRow} open={assignopen} setOpen={setAssignOpen} dispatchData={data} />
        )}
        {startOpen && selectedRow && (
          <StartConfirmation
            row={selectedRow}
            open={startOpen}
            setOpen={setStartOpen}
            dispatchData={data}
            start={type}
          />
        )}
      </Box>
    </GlobalWrapper>
  );
};

export default Batchlanding;
